import React, { useState } from "react";
import "./AIChatInterface.scss";
import { ReactComponent as X } from "../../assets/images/X.svg";
import { ReactComponent as SendIcon } from "../../assets/icons/send_icon.svg";
import { sendMessageToGPT } from "../../services/ai-services";
import { useDealershipUserContext } from "../../contexts/dealershipUserContext";
import { saveAIChatMessages } from "../../services/dealership-user";

export const AIChatInterface = ({ close }) => {
  const { user, setUser, userId } = useDealershipUserContext();
  const initializeMessages = () => {
    return user && user?.aiChatHistory.length > 0
      ? user.aiChatHistory
      : [{ from: "Mae", text: "Hi, How can i help you!" }];
  };
  const [userMessages, setUserMessages] = useState([]);
  const [assistantMessages, setAssistantMessages] = useState([
    "Hi, How can i help you!",
  ]);
  const [messages, setMessages] = useState(initializeMessages());
  const [input, setInput] = useState("");

  const handleSend = async (e) => {
    setInput("");
    e.preventDefault();
    if (!input.trim()) return;
    setMessages((prevMessagesThread) => [
      ...prevMessagesThread,
      { from: user?.firstName || "User", text: input },
      { from: "Mae", text: "..." },
    ]);
    setUserMessages((prevMessages) => [...prevMessages, input]);
    const res = await sendMessageToGPT(input);
    setAssistantMessages((prevMessages) => [...prevMessages, res]);
    setMessages((prevMessagesThread) => [
      ...prevMessagesThread.slice(0, -1),
      { from: "Mae", text: res },
    ]);
    const updatedUser = await saveAIChatMessages(
      [
        { from: user?.firstName || "User", text: input },
        { from: "Mae", text: res },
      ],
      userId
    );
    setUser(updatedUser);
  };

  return (
    <div className="ai-chat-interface-widget__container">
      <div className="ai-chat-interface-widget__header">
        <div className="ai-chat-interface-widget__title">Chat with us</div>
        <X onClick={() => close()} />
      </div>
      <div className="ai-chat-interface-widget__messages">
        {messages.map((msg, index) => (
          <div
            key={index}
            className={
              msg.from === "Mae"
                ? "ai-chat-interface-widget__message-ai"
                : "ai-chat-interface-widget__message-user"
            }
          >
            <strong>{msg.from}:</strong> {msg.text}
          </div>
        ))}
      </div>
      <form
        className="ai-chat-interface-widget__input-container"
        onSubmit={handleSend}
      >
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Type your message..."
          className="ai-chat-interface-widget__input"
        />
        <SendIcon onClick={handleSend} />
      </form>
    </div>
  );
};
